module.exports = __webpack_public_path__ + "img/empty_inventory.32cba970.svg";